<ng-container *transloco="let t; read: 'authentication'">
  <div
    role="button"
    tabindex="0"
    [attr.aria-label]="t('MICROSOFT_SIGN_IN')"
    (click)="clickEvent.emit()"
    (keyup.enter)="clickEvent.emit()"
    (keyup.space)="clickEvent.emit()"
  >
    <img src="assets/logo_microsoft.svg" alt="{{ t('MICROSOFT_LOGO') }}" />
    <span>{{ t('MICROSOFT_SIGN_IN') }}</span>
  </div>
</ng-container>
